import { createFileRoute } from "@tanstack/react-router";
import UkPrivacy from "@/pages/legal/UkPrivacy";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/fr/privacy/")({
  head: () => routeHead("/fr/privacy/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UkPrivacy />
  );
}
